import { getAccessToken, clearAccessTokenKeepUser, redirectToAuth } from "./auth";

function resolveApiUrl(input) {
    if (typeof input === "string" && /^https?:\/\//i.test(input)) return input;
    const base = process.env.VUE_APP_API_BASE_URL || "";
    if (!base) return input;
    const normalizedBase = base.endsWith("/") ? base : `${base}/`;
    const normalizedPath = `${input}`.replace(/^\/+/, "");
    return `${normalizedBase}${normalizedPath}`;
}

function buildHeaders(initHeaders, { auth } = {}) {
    const headers = new Headers(initHeaders || {});
    if (!headers.has("Accept")) headers.set("Accept", "application/json");
    if (auth) {
        const token = getAccessToken();
        if (token) headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
}

export async function apiFetch(input, init = {}, options = {}) {
    const { auth = true } = options;
    const url = resolveApiUrl(input);
    const headers = buildHeaders(init.headers, { auth });
    const res = await fetch(url, { ...init, headers });
    if (auth && res.status === 401) {
        clearAccessTokenKeepUser();
        if (typeof window !== "undefined" && window.location?.pathname !== "/auth") {
            redirectToAuth("401");
        }
        throw new Error("Unauthorized (401)");
    }
    return res;
}

export async function apiFetchJson(input, init = {}, options = {}) {
    const res = await apiFetch(input, init, options);
    const contentType = res.headers.get("content-type") || "";
    if (!res.ok) {
        let message = `Request failed (${res.status})`;
        try {
            if (contentType.includes("application/json")) {
                const err = await res.json();
                if (err?.error) message = err.error;
                else if (err?.message) message = err.message;
            } else {
                const text = await res.text();
                if (text) message = text;
            }
        } catch {
            // ignore
        }
        throw new Error(message);
    }
    if (contentType.includes("application/json")) return await res.json();
    const text = await res.text();
    return text;
}

